<app-formulario #ctrl URL="grupo/matricula" titulo="Alumno / Control Escolar" [dato]="dato"></app-formulario>
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
  <div class="column is-hidden-mobile menu-izquierda is-2">
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; ">
      <!-- formulario -->
      <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar(false)">
        <section class="hero is-primary">
          <div class="hero-body">
            <nav class="level">
              <!-- Left side -->
              <div class="level-left">
                <div class="level-item">
                  <p class="title">
                    <span *ngIf="!ctrl.cargando" class="icon is-medium">
                      <i class="icon-money-12"></i>
                    </span>
                    <span *ngIf="ctrl.cargando" class="icon is-medium">
                      <i class="fa fa-refresh fa-spin"></i>
                    </span>
                    <span class="icon is-medium">
                      <i class="fa fa-file"></i>
                    </span> Incorporación financiera
                  </p>
                </div>

              </div>

              <!-- Right side -->
              <div class="level-right">
                <a class="navbar-item tooltip" (click)="ctrl.regresar()">
                  <span class="icon fa-2x">
                    <i class="fa fa-arrow-left"> </i>
                  </span>
                  <span class="tooltiptext">Regresar</span>
                </a>

                <button class="navbar-item  is-success tooltip" type="submit" [ngClass]="{'is-loading': ctrl.cargando}"
                  [disabled]="ctrl.dato.invalid || ctrl.cargando">
                  <span class="icon fa-2x has-text-success">
                    <i class="fa fa-save"> </i>
                  </span>
                  <span class="tooltiptext">Guardar</span>
                </button>
              </div>
            </nav>

          </div>
        </section>
        <div id="banner" align="center" *ngIf="ctrl.cargando || cargarDatosCatalogo">
          <div class="bloquear-azul">

          </div>
          <span class="tag is-primary is-large "
            style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
            <span class="icon">
              <i class="fa fa-refresh fa-spin"></i>
            </span> &nbsp;
            <span>Cargando...</span>
          </span>
        </div>
        <section class="section" style="padding: 1rem; height: 87.2vh;">

          <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
          <a id="catalogos" (click)="ctrl.cargarCatalogo('periodos_escolares', 'periodo-escolar-catalogo');"></a>
          <a id="message" (click)="ctrl.mostrar_mensaje(titulo, mensaje, clase);"></a>
          <div class="columns">
            <div class="column is-6">
              <label class="label">Período escolar: </label>
              <div class="control has-icons-left has-icons-right">

                <span class="icon is-small is-left">
                  <i class="icon-worldwide fa-spin" *ngIf="ctrl.cargando_periodo"></i>
                </span>

                <ng-select2
                  [disabled]="ctrl.periodos_escolares ? ctrl.periodos_escolares.length == 0 ? true : false : true"
                  [options]="ctrl.optionSelect" ([ngModel])="periodo_escolar"
                  (valueChanged)="ctrl.grupos = []; ctrl.seleccionarValorSelect2($event, 'periodo_escolar', 'grupos-calificaciones', 'grupos');"
                  [data]="ctrl.periodos_escolares"></ng-select2>
              </div>
            </div>
            <div class="column is-6">
              <label class="label">Grupo:</label>
              <div class="control has-icons-left has-icons-right">
                <ng-select2 [disabled]="ctrl.grupos ? ctrl.grupos.length == 0 ? true : false : true"
                  [options]="ctrl.optionSelect" ([ngModel])="grupo"
                  (valueChanged)="detalleGrupo($event, ctrl.periodo_escolar);" [data]="ctrl.grupos"></ng-select2>
              </div>
            </div>

          </div>
          <div class="box" *ngIf="carrera_plan">
            <article class="media">
              <div class="media-content">
                <nav class="level">
                  <div lass="level-left">
                    <div class="level-item">
                      <p align="center">

                        <strong>Carrera Plan:</strong> {{carrera_plan.planes_estudios.nombre}}
                        <strong> Carrera:</strong> {{carrera_plan.carreras.nombre}}
                        <br>
                        <strong> Modalidad:</strong> {{grupo.periodos_escolares.modalidades.nombre}}
                        <span> Grupo: {{grupo.clave}}</span>
                        <span> Nivel: {{grupo.nivel}} {{grupo.identificador}}</span>

                      </p>
                    </div>
                  </div>
                </nav>

                <div class="content" style="overflow-y:auto;height: 58vh;">

                  <table class="table is-striped is-fullwidth" style="width:100% !important;">
                    <thead>
                      <tr>
                        <th><abbr>ID</abbr></th>
                        <th>Alumno</th>
                        <th>Matrícula</th>
                      </tr>
                    </thead>
                    <tbody formArrayName="grupos">
                      <tr *ngFor="let val of ctrl.dato.controls.grupos.controls; let i = index;" [formGroupName]="i" [ngClass]="{'blue-class': color[val.value.personas_id]}">
                        <td style="vertical-align: middle;">{{ i + 1 }}</td>
                        <td style="vertical-align: middle;"><strong>{{ val.value.matricula }}</strong>
                          {{ val.value.nombre }} </td>
                        <td style="vertical-align: middle;">
                          <nav class="level" style="float:right">
                            <div class="level-right">

                            <button class="button" type="button" (click)="abrirModal('inicializacion', val.value, i)" class="navbar-item"
                              *ngIf="val.value.alumnos_inicializacion==0 && permisos.indexOf('AlumnoOperacionController.inicializacion') > -1 ">
                              <span class="icon fa-2x has-text-success">
                                <i class="icon-clock2"></i>
                              </span>

                              <span class="has-text-success">&nbsp; Incorporación académico-financiera</span>
                            </button>

                            <button class="button" type="button" (click)="abrirModal('desinicializacion', val.value, i)" class="navbar-item "
                              *ngIf="val.value.alumnos_inicializacion==1 && permisos.indexOf('AlumnoOperacionController.desinicializar') > -1 ">
                              <span class="icon fa-2x has-text-danger">
                                <i class="icon-swap"></i>
                              </span>

                              <span class="has-text-danger">&nbsp;Deshacer incorporación académico-financiera</span>
                            </button>


                            </div>
                          </nav>

                        </td>

                      </tr>
                      <tr *ngIf="ctrl.dato.controls.grupos.length == 0">
                        <td colspan="3" style="vertical-align: middle; color:#888;">Sin alumnos en el grupo.</td>
                      </tr>
                    </tbody>

                  </table>

                </div>
              </div>
            </article>
          </div>

        </section>
      </form>

      <div [formGroup]="data">
        <div class="modal" id="desinicializacion">
          <div class="modal-background"></div>
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title">
                <i class="fa fa-warning"></i> Confirmación</p>
              <button class="delete" (click)="ctrl.cancelarModal('desinicializacion')"></button>
            </header>
            <section class="modal-card-body">
              <div class="content">
                <h1>¿Esta seguro de cancelar la incorporación académico-financiera?</h1>
                <p>Al aceptar: se eliminan pagos de tipo colegiatura e inscripciones y permitirá la incorporación
                  académico-financiera nuevamente</p>
              </div>
            </section>
            <footer class="modal-card-foot">
              <a class="button is-success" (click)="guardar(data.controls.id.value, 'desinicializacion')">Continuar</a>
              <a class="button" (click)="cancelarModal('desinicializacion')">Cancelar</a>
            </footer>
          </div>
        </div>

        <div class="modal" id="inicializacion">
          <div class="modal-background"></div>
          <div class="modal-card" style="width: 60%;">
            <header class="modal-card-head">
              <p class="modal-card-title">
                <span class="icon">
                  <i class="icon-list-12"></i>
                </span> Incorporación académico-financiera
              </p>
              <button type="button" class="delete" (click)="cancelarModal('inicializacion')"></button>
            </header>
            <section class="modal-card-body">
              <div>
                <div class="columns">
                  <div class="column">
                    Seleccione una de las opciones del combo "Última colegiatura pagada". El sistema utilizará estos datos
                    como
                    referencia para el proceso de cobranza de colegiaturas
                  </div>
                </div>
                <div class="columns" formGroupName="alumnos_inicializacion">
                  <div class="column is-4">
                    <label class="label">Última colegiatura abonada incompleta</label>
                    <div class="control has-icons-left has-icons-right">
                      <div class="select">
                        <select class="select" name="mes"
                          [ngClass]="{'is-danger': data.controls.alumnos_inicializacion.get('mes').hasError('required') }"
                          formControlName="mes">
                          <option value="0">Seleccione</option>
                          <option value="{{item}}" *ngFor="let item of mensualidades">{{item}}a</option>
                        </select>
                      </div>
                    </div>
                    <span class="icon is-small is-right"
                      *ngIf="data.controls.alumnos_inicializacion.get('mes').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger"
                      *ngIf="data.controls.alumnos_inicializacion.get('mes').hasError('required')">Este campo es
                      requerido.</span>
                  </div>

                  <div class="column is-4">
                    <div class="b-checkbox is-info">
                      <input id="completado" class="styled"
                        [checked]="data.controls.alumnos_inicializacion.get('completado').value == '1' ? true : false"
                        (change)="data.controls.alumnos_inicializacion.get('completado').patchValue(data.controls.alumnos_inicializacion.get('completado').value == '1' ? '0' : '1')"
                        type="checkbox">
                      <label for="completado">
                        Última colegiatura abonada incompleta
                      </label>
                    </div>
                  </div>
                  <div class="column is-4">
                    <div class="field" *ngIf="data.controls.alumnos_inicializacion.get('completado').value == 1">
                      <label class="label">Cantidad Abonada:</label>
                      <p class="control has-icons-left has-icons-right">
                        <input class="input" type="number" placeholder="Cantidad abonada" formControlName="ultimo_abono">
                      </p>
                    </div>
                  </div>

                </div>
              </div>
            </section>
            <footer class="modal-card-foot">
              <a class="button is-success" (click)="guardar(data.controls.id.value,'inicializacion')">Guardar</a>
              <a class="button" (click)="cancelarModal('inicializacion')">Cancelar</a>
            </footer>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


